import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import ScrollToTop from "./ScrollToTop";

const Layout = () => {
  const { pathname } = useLocation();
  const transparentHero = pathname === "/";
  const footerRef = useRef(null);

  useEffect(() => {
    const el = footerRef.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          document.documentElement.classList.add("no-scrollbar");
        } else {
          document.documentElement.classList.remove("no-scrollbar");
        }
      },
      { root: null, threshold: 0.05 }
    );
    io.observe(el);
    return () => {
      io.disconnect();
      document.documentElement.classList.remove("no-scrollbar");
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[color:var(--vw-bg)]">
      <ScrollToTop />
      <Navbar transparentHero={transparentHero} />
      <main className={`flex-1 ${transparentHero ? "" : "pt-16 md:pt-20"}`}>
        <Outlet />
      </main>
      <div ref={footerRef}>
        <Footer />
      </div>
      <CartDrawer />
    </div>
  );
};

export default Layout;
